import {
  ExtendedResource,
  type ExtendedResourceConstructor,
} from '#src/ExtendedResource.ts'
import * as modelsModule from '#src/models/index.ts'
import { registerResourceModel } from '#src/registry/registry.ts'

/* Defer registration to allow all ESM modules to fully initialize.
 * ESM live bindings can be in a temporal dead zone during circular
 * module evaluation; deferring to a microtask ensures all class
 * declarations have executed before we iterate the namespace. */
queueMicrotask(() => {
  for (const exportedItem of flattenExports(modelsModule)) {
    registerResourceModel(exportedItem)
  }
})

/**
 * Recursively flattens exports to find all ExtendedResource classes, including those in arrays or nested objects
 */
function flattenExports(
  moduleExports: any
): ExtendedResourceConstructor<any>[] {
  const flattened: ExtendedResourceConstructor<any>[] = []

  if (moduleExports === null || moduleExports === undefined) {
    return flattened
  }

  // If it's a function and an ExtendedResource class, add it
  if (
    typeof moduleExports === 'function' &&
    moduleExports.prototype instanceof ExtendedResource &&
    'RESOURCE_TYPE' in moduleExports &&
    typeof (moduleExports as any).RESOURCE_TYPE === 'string'
  ) {
    flattened.push(moduleExports)
  }
  // If it's an array, recursively flatten each element
  else if (Array.isArray(moduleExports)) {
    for (const item of moduleExports) {
      flattened.push(...flattenExports(item))
    }
  }
  // If it's an object (likely a named export module), recursively flatten it
  else if (typeof moduleExports === 'object') {
    for (const exportedItem of Object.values(moduleExports)) {
      flattened.push(...flattenExports(exportedItem))
    }
  }

  return flattened
}
